import { FC, ReactNode, useEffect, useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { styled } from '@mui/material/styles';

import type { NavColor } from 'src/types/settings';

import type { Section } from '../config';
import { MobileNav } from '../mobile-nav';
import { SideNav } from './side-nav';
import { TopNav } from './top-nav';
import { useMobileNav } from './use-mobile-nav';
import { Backdrop, Modal, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useSelector } from 'react-redux';
import useCheckRole from 'src/hooks/use-check-role';


const SIDE_NAV_WIDTH = 280;

const VerticalLayoutRoot = styled('div')(({ theme }) => ({
  display: 'flex',
  flex: '1 1 auto',
  maxWidth: '100%',
  [theme.breakpoints.up('lg')]: {
    paddingLeft: SIDE_NAV_WIDTH,
  },
}));

const VerticalLayoutContainer = styled('div')({
  display: 'flex',
  flex: '1 1 auto',
  flexDirection: 'column',
  width: '100%',
});

interface VerticalLayoutProps {
  children?: ReactNode;
  navColor?: NavColor;
  sections?: Section[];
}

export const VerticalLayout: FC<VerticalLayoutProps> = (props) => {
  const { children, sections, navColor } = props;
  const lgdown = useMediaQuery((theme: any) => theme.breakpoints.down('1600'));
  const mobileNav = useMobileNav();
  const [isSideNav, setIsSideNav] = useState<boolean>(false);
  const therapistProfile = useSelector((state: any) => state.getTherapistProfileReducer);
  const [isTherapist] = useCheckRole('therapist');
  const [isAssistant] = useCheckRole('assistant');
  const [isStudent] = useCheckRole('student');



  useEffect(() => {
    if (lgdown) setIsSideNav(false);
    else setIsSideNav(true);
  }, [lgdown]);
  return (
    <>
      <TopNav
        onMobileNavOpen={mobileNav.handleOpen}
        isSideNav={isSideNav}
      />
      {
        <SideNav
          color={navColor}
          sections={sections}
          setIsSideNav={setIsSideNav}
          isSideNav={isSideNav}
        />
      }
      {/* {!lgUp && (
        <MobileNav
          color={navColor}
          onClose={mobileNav.handleClose}
          open={mobileNav.open}
          sections={sections}
        />
      )} */}
      <div
        style={{
          display: 'flex',
          flex: '1 1 auto',
          maxWidth: '100%',

          paddingLeft: isSideNav ? SIDE_NAV_WIDTH : '68px',
          transition: 'paddingLeft 0.5s ease ',
        }}
      >
        <VerticalLayoutContainer>{children}</VerticalLayoutContainer>
      </div>
      
      {!therapistProfile?.loader && (
        <Backdrop
          open={
            // If user is not a therapist, assistant, or student then don't show the modal
            !(isTherapist || isAssistant || isStudent)? false :
            therapistProfile?.response?.data?.licenseNumber &&
            therapistProfile?.response?.data?.expirationDate
              ? new Date().setUTCHours(0, 0, 0, 0) >
                new Date(therapistProfile?.response?.data?.expirationDate).setUTCHours(0, 0, 0, 0)
              : true
          }
          sx={{
            position: 'fixed',
            top: 64,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 1200,
          }}
        >
          <Box
            sx={{
              backgroundColor: 'white',
              borderRadius: '8px',
              padding: '20px',
              width: '70%',
              maxWidth: '520px',
              margin: 'auto',
            }}
          >
            <Typography
              variant="h5"
              sx={{ marginBottom: '20px' }}
            >
              Therapist License Required
            </Typography>
            <Typography>
              You do not have an active license for the state of the facility you&apos;re logged into.
              Please contact your management to update or renew your license.
              <br /> License details can be updated in your Enterprise Portal.
            </Typography>
          </Box>
        </Backdrop>
      )}
    </>
  );
};
